/* eslint-disable react/prop-types */
import { useEffect } from 'react'
import { withRouter } from 'react-router-dom'

function ScrollToTop({ history, location }) {
  useEffect(() => {
    const scrollToHashOrTop = (loc) => {
      const hash = (loc && loc.hash) || window.location.hash
      if (hash) {
        const id = hash.replace('#', '')
        const scrollToElement = () => {
          const element =
            document.getElementById(id) ||
            (id === 'contact' ? document.getElementById('contactForm') : null)
          if (element) {
            const yOffset = -80
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
            window.scrollTo({ top: y, behavior: 'smooth' })
            return true
          }
          return false
        }

        if (!scrollToElement()) {
          setTimeout(scrollToElement, 150)
          setTimeout(scrollToElement, 400)
          setTimeout(scrollToElement, 800)
        }
      } else {
        window.scrollTo(0, 0)
      }
    }

    scrollToHashOrTop(location)

    const unlisten = history.listen((newLocation) => {
      scrollToHashOrTop(newLocation)
    })

    return () => {
      unlisten()
    }
  }, [history, location])

  return null
}

export default withRouter(ScrollToTop)

